import React from 'react'
import { BrowserRouter,NavLink, Route, Routes } from 'react-router-dom';
import './App.css';
import PathwaySelector from './components/PathwaySelector/';
const Home = () => <h1>Home</h1>;
function App() {
  return (PathwaySelector());
}
export default App;
